var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("path",{"d":"M30.34342,7.69390526e-05 L34.741124,4.09024917 L30.343371,8.17936866 L29.66238,7.44703134 L32.735,4.58907694 L5.68434189e-14,4.5898 L5.68434189e-14,3.5898 L32.733,3.58907694 L29.66238,0.732323061 L30.34342,7.69390526e-05 Z"})));
}

ArrowInline.defaultProps = {"width":"35px","height":"9px","viewBox":"0 0 35 9","version":"1.1"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
